import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../lib/api'

export default function CustomerNewPage() {
  const navigate = useNavigate()
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [customerType, setCustomerType] = useState('OTHER')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    if (!name.trim()) return setError('Name is required')
    setSaving(true)
    try {
      const res = await api.customers.create({ name, email, phone, customerType })
      navigate(`/customers/${res.data.customer.id}`)
    } catch (err: any) {
      setError(err?.response?.data?.error ?? 'Failed to create customer')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="max-w-3xl mx-auto p-6 space-y-4">
      <h1 className="text-2xl font-bold">New Customer</h1>
      {error && <div className="border border-red-200 bg-red-50 text-red-700 px-3 py-2 rounded text-sm">{error}</div>}
      <form className="bg-white border rounded-xl p-4 grid grid-cols-1 md:grid-cols-2 gap-3" onSubmit={submit}>
        <input className="border rounded px-3 py-2 text-sm" value={name} onChange={(e) => setName(e.target.value)} placeholder="Customer name" />
        <select className="border rounded px-3 py-2 text-sm" value={customerType} onChange={(e) => setCustomerType(e.target.value)}>
          <option value="BROKER">BROKER</option>
          <option value="SHIPPER">SHIPPER</option>
          <option value="DEALER">DEALER</option>
          <option value="OTHER">OTHER</option>
        </select>
        <input className="border rounded px-3 py-2 text-sm" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" />
        <input className="border rounded px-3 py-2 text-sm" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone" />
        <div className="md:col-span-2 flex gap-2">
          <button disabled={saving} className="bg-blue-700 text-white px-4 py-2 rounded text-sm">{saving ? 'Saving...' : 'Create'}</button>
          <button type="button" onClick={() => navigate('/customers')} className="border px-4 py-2 rounded text-sm">Cancel</button>
        </div>
      </form>
    </div>
  )
}
